/**
 * `packages/ui` bileşenlerinin varsayılan (erişilebilirlik) metinleri — Türkçe. Uygulama metinleri burada DEĞİL,
 * `apps/web/src/i18n/tr.ts`'tedir. Her metin ilgili bileşende prop ile değiştirilebilir; kapsamlı i18n kurulmaz (K-8).
 */
export const uiStrings = {
    close: 'Kapat',
    loading: 'Yükleniyor',
    required: 'zorunlu',
    optional: 'isteğe bağlı',
    skipToContent: 'İçeriğe geç',
    mainNavigation: 'Ana menü',
    breadcrumb: 'Konum',
    openNavigation: 'Menüyü aç',
    closeNavigation: 'Menüyü kapat',
    collapseSidebar: 'Menüyü daralt',
    expandSidebar: 'Menüyü genişlet',
    // v3.9 alan navigasyonu
    mainAreas: 'Ana alanlar',
    areaPages: (area) => `${area} sayfaları`,
    hidePanel: 'Sayfa panelini gizle',
    showPanel: 'Sayfa panelini göster',
    backToAreas: 'Ana alanlar',
    currentArea: 'Buradasınız',
    soon: 'Yakında',
    selectAllRows: 'Bu sayfadaki tüm satırları seç',
    selectRow: (label) => `Satırı seç: ${label}`,
    selectedCount: (n) => `${n} satır seçildi`,
    clearSelection: 'Seçimi temizle',
    sortAscending: 'artan sıralı',
    sortDescending: 'azalan sıralı',
    sortable: 'sıralanabilir',
    previousPage: 'Önceki sayfa',
    nextPage: 'Sonraki sayfa',
    totalExact: (n) => `${n.toLocaleString('tr-TR')} kayıt`,
    totalAtLeast: (n) => `${n.toLocaleString('tr-TR')}+ kayıt`,
    activeFilters: 'Etkin filtreler',
    clearFilters: 'Filtreleri temizle',
    removeFilter: (label) => `Filtreyi kaldır: ${label}`,
    notifications: 'Bildirimler',
    cancel: 'Vazgeç',
    retry: 'Yeniden dene',
    dismissNotice: 'Bildirimi kapat',
    noOptions: 'Eşleşen seçenek yok',
    removeTag: (name) => `Etiketi kaldır: ${name}`,
    // Tema uyarlaması: taşan sekmeler menüsü
    moreTabs: 'Diğer sekmeler',
    moreTabsShort: 'Diğer',
    // Z6: kaydırılabilir sekme şeridinde kesilen sekmelere ipucu
    tabsScrollNext: 'Sonraki sekmeleri göster',
    tabsScrollPrev: 'Önceki sekmeleri göster',
};
//# sourceMappingURL=strings.js.map